module.exports = __webpack_public_path__ + "static/media/bgd1Empty@2x.ec438d97.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/activity50/bgd1Empty@2x.png
// module id = 340
// module chunks = 0